import { ENV_JS } from '../utils/env_module'
import { windowDispachStorage } from '../utils/app_module';

callpy_global.CBridge = function()
{
    this.module_name = "Bridge ";
    //defines module priority to log?
    this.module_log_rang = 100;

    var _this = this;

    //defines Flash on the page?
    this.flash_object = null;

    this.init = function()
    {
        //инициализация "моста" - формирует обработчики событий для общения между внутренним iframe и основной страницей (для менеджера)
        var listener = null;

        if (m_callpy.client_data.type == 1){
            listener = function(event)
            {
                //fix window.location.origin for ie
                if (!window.location.origin) {
                    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
                }
                if (event.origin == window.location.origin){
                    m_callpy.m_bridge.from_proxy_client(event.data);
                }
            };
        }

        if (m_callpy.client_data.type == 2)
        {
            listener = function(event)
            {
                if (event.origin==m_callpy.client_data.origin){
                    m_callpy.m_bridge.from_proxy(event.data);
                }
            };
        }
        if (m_callpy.client_data.type == 3)
        {
            listener = function(event)
            {
                if (event.origin == callpy_global.php_server.substr(0, callpy_global.php_server.length-1).replace("https", "http") || event.origin == callpy_global.php_server.substr(0, callpy_global.php_server.length-1)){
                    m_callpy.m_bridge.from_parent(event.data);
                }
            };
        }

        if (m_callpy.client_data.type == 4)
        {
            listener = function(event)
            {
                //fix window.location.origin for ie
                if (!window.location.origin) {
                    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
                }
                if (event.origin == window.location.origin){
                    m_callpy.m_bridge.from_parent_client(event.data);
                }
            };
        }

        if (listener)
        {
            if (window.addEventListener)
            {
                window.addEventListener("message", listener,false);
            }
            else
            {
                window.attachEvent("onmessage", listener);
            }
        }
    };

    //Handles messages from Flash
    //Сейчас данные приходят на самом деле от PHP
    this.from_flash = function(data)
    {
      m_callpy.m_logger.log(_this.module_name + "<<<--- Flash", data);

      //===> NEED FOR REACT VERSION ===================
      windowDispachStorage({data})
      //==============END=================================
        


        //data: json {"action": "actionType", ...other data...}
        if (data)
        {
          switch (data["action"])
          {
              case "register_client": //php fms
                  m_callpy.register_client(data);
                  break;
              //ответ сервера при добавлении быстрого ответа
              case "phrase_added":
                  m_callpy.m_manager.phrase_added(data);
                  break;
              case "unregister_client":
                  m_callpy.unregister_client(data);
                  break;
              case "manager_changed": //php при смене любого менеджера
                  m_callpy.manager_changed(data);
                  break;
              case "end_call": //peer когда звонок закончен
                  if (m_callpy.m_chat)
                  {
                      //TODO: возможно, написать системное сообщение в чат (см. вызываемую функцию)
                      //m_callpy.m_chat.end_call_from_peer();

                      //UPDATED: вызовем форму оценки диалога (возможно, другая форма необходима?)
                      if (m_callpy.m_user){
                          m_callpy.m_chat.dialogClosed();
                      }
                  }
                  break;
              //peer прислал сообщение об отмене дозвона
              case "end_dialup":
                  if (m_callpy.m_chat)
                  {
                      //TODO: системное сообщение в чат
                      m_callpy.m_chat.end_dialup_from_peer(data);
                      if (m_callpy.m_user){
                          $jcallpy.callpy_notification('call_stop');
                      }
                  }
                  break;
              case "chat_answ": //peer ответ на звонок
                  /*
                  if (m_callpy.m_chat)
                  {
                      clearTimeout(m_callpy.m_flash.dialupTimer);
                      if (data["peerRTCType"]) m_callpy.m_flash.peer_webRTCtype = data["peerRTCType"];
                      if (m_callpy.m_flash.peer_webRTCtype == m_callpy.m_flash.webRTCtype || m_callpy.m_flash.peer_webRTCtype!="chrome"){
                          m_callpy.m_flash.createOffer();
                      }
                      m_callpy.m_chat.answer(data);
                  }
                  */
                  break;
              case "chat_call": //peer входящий вызов
                  if (m_callpy.m_chat)
                  {
                      //FIXED: коллизии при одновременной попытке звонка
                      //if (m_callpy.m_flash.access_equip && (m_callpy.m_user || (m_callpy.m_manager && m_callpy.m_manager.selected_user == data["key"]))){
                      if ((m_callpy.m_user && (m_callpy.m_flash.access_equip || localStorage.getItem("callpy_call_flag") == "2")) || (m_callpy.m_flash.access_equip && m_callpy.m_manager && m_callpy.m_manager.isClientSelected(data["site_id"], data["key"]))){
                          m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("end_dialup"));
                      }else{

                          m_callpy.m_chat.call_type = data["webRTC"]; //0 - звонок по флешке, 1 - через webRTC
                          m_callpy.m_flash.call_type = (data["webRTC"]?"webrtc":"flash");
                          m_callpy.m_flash.peer_webRTCtype = data["peerRTCType"]?data["peerRTCType"]:"chrome";
                          if (m_callpy.m_manager){
                              m_callpy.m_flash.currentClient = data["key"]; //запоминаем текущего клиента с которым идет дозвон / звонок
                              m_callpy.m_flash.currentSiteId = data["site_id"]; //клиент, с которым в данный момент идет дозвон / звонок
                              if (m_callpy.m_manager.isClientSelected(data["site_id"], data["key"])) m_callpy.m_chat.call_status = "incoming";
                              m_callpy.users_list[data["site_id"]][data["key"]].isActive = 2;
                              $jcallpy.general_panel('add', {id: data["key"], site_id: data["site_id"]});
                              $jcallpy.callpy_notify('drawNotification', {siteId: data["site_id"], clientId: data["key"], siteUrl: m_callpy.client_data.site_info[data["site_id"]].domain, type: "incoming", title: "№"+data["key"]+", "+m_callpy.users_list[data["site_id"]][data["key"]].city, text: _("Входящий звонок...")});
                          }else {
                              /*
                              //localStorage.setItem("callpy_incoming_call", "1");
                              if (m_callpy.m_storage.restoreInIE) m_callpy.m_storage.handleCallFlag = false;
                              localStorage.setItem("callpy_call_flag", "1"); //входящий
                              //FIXED: у клиента теперь тоже значение call_status меняется на "incoming"
                              m_callpy.m_chat.call_status = "incoming";
                              */
                              localStorage.setItem("callpy_call_flag", "1");
                              m_callpy.m_chat.call_status = "incoming";
                              $jcallpy.callpy_status('set', 'incoming_call_on');
                              $jcallpy.callpy_notification('call');
                          }

                      }
                  }
                  break;
              case "call_state": //переключение между аудио и видео режимами
                  /*
                  if (data["state"]=="video"){ //peer переключился в видео-режим
                      m_callpy.m_flash.peer_to_video(data);
                  }
                  if (data["state"]=="audio"){ //peer переключился в видео-режим
                      m_callpy.m_flash.peer_to_audio(data);
                  }
                  */
                  break;
              case "call_createOffer": //от пира приходит сообщение, что необходимо сгенерировать createOffer() (важно, кто именно его генерирует)
                  //m_callpy.m_flash.createOffer();
                  break;
              case "peerDisabledCamera":
                  //TODO GUI: вызов отрисовки заглушки
                  break;
              case "callToAudio":
                  /*
                  if (m_callpy.m_flash.stream.getVideoTracks().length) m_callpy.m_flash.stream.getVideoTracks()[0].enabled = false;
                  if (m_callpy.m_user){
                      $jcallpy.callpy_call('off_video');
                  }
                  else{
                      $jcallpy.chat('off_video');
                  }
                  */
                  break;
              case "get_user_page": //peer менеджер запрашивает страницу клиента
                  if (m_callpy.m_user)
                  {
                      m_callpy.m_user.get_user_page(data);
                  }
                  break;
              case "update_active_state": //сервер генерирует нам сообщение о необходимости изменения активности страницы (надо ли посылать менеджеру сообщения о кликах, скроллах и т.п.)
                  if (m_callpy.m_user)
                  {
                      m_callpy.m_user.update_active_state(data);
                  }
                  break;
              case "tab_visibility": //видима ли у клиента хотя бы одна вкладка
                  if (m_callpy.m_manager){
                      m_callpy.m_manager.tab_visibility(data);
                  }
                  break;
              case "go_url": //peer переход по странице
                  m_callpy.go_url(data);
                  break;
              case "set_new_user":
                  if (m_callpy.m_manager) m_callpy.m_manager.set_new_user(data);
                  break;
              case "send_message": //peer отправить сообщение
              //case "send_automessage":
                  if (m_callpy.m_chat)
                  {
                      m_callpy.m_chat.get_message(data);
                  }
                  break;
              case "send_message_self": //сам отправил сообщение (для синхронизации)
                  if (m_callpy.m_chat && !m_callpy.m_chat.block_from_self){
                      m_callpy.m_chat.get_message_self(data["data"]);
                  }else{
                      m_callpy.m_chat.block_from_self = false;
                  }
                  break;
              case "get_message_dialog":
                  if (m_callpy.m_chat)
                  {
                      m_callpy.m_chat.get_message_dialog(data);
                  }
                  break;
              case 'edit_message':
                  if (m_callpy.m_chat){
                      m_callpy.m_chat.edit_message(data);
                  }
                  break;
              case "automessage":
                  if (m_callpy.m_manager) m_callpy.m_manager.got_automessage(data);
                  break;
              case "message_received":
                  if (m_callpy.m_chat){
                      m_callpy.m_chat.message_received(data);
                  }
                  break;
              case "setMessagesRead":
                  if (m_callpy.m_chat){
                      m_callpy.m_chat.set_messages_read(data);
                  }
                  break;
              case "set_message_history": //php история для клиента
                  if (m_callpy.m_chat)
                  {
                      m_callpy.m_chat.set_message_history(data);
                  }
                  break;
              case "get_scroll_cw": //php менеджер запрашивает скрол у клиента
                  if (m_callpy.m_control)
                  {
                      //запрашиваем скролл только у активной вкладки
                      var scroll = 0;
                      if (m_callpy.m_storage.activeTab == true){
                          if (m_callpy.m_chat.call_status!="call"){
                              //m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("scroll", {0: m_callpy.m_control.get_top_scroll()}));
                              scroll = m_callpy.m_control.get_top_scroll();
                          }else{ //запрос пришел от менеджера во время звонка, соответственно, необходимо получить скролл в iframe
                              //m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("scroll", {0: document.getElementById('callpy_iframeid').contentWindow.m_callpy.m_control.get_top_scroll()}));
                              scroll = document.getElementById('callpy_iframeid').contentWindow.m_callpy.m_control.get_top_scroll();
                          }

                          //var cookie = document.cookie;
                          var size = 0;
                          if (m_callpy.m_storage.activeTab == true) size = $jcallpy(window).width();

                          //m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("scroll_cw", {0: scroll, 1: cookie, 2: size}))

                      }
                      //FIXED: от неактивных вкладок передаем scroll = 0, а при обработке у менеджера не меняем, если приходит 0 (т.к. 0 по умолчанию)
                      m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("scroll_cw", {
                          "height": scroll,
                          "cookie": document.cookie,
                          "inputs": m_callpy.m_control.getInputs()
                      }));

                  }
                  break;
              case "scroll": //peer скрол
                  if (m_callpy.m_control)
                  {
                      if (m_callpy.client_data.type=="1" && (localStorage.getItem("callpy_control_flag")!="2" || (m_callpy.m_storage.activeTab != true && ((m_callpy.m_chat.call_status!="call" && window.location.href != data["url"]) || (m_callpy.m_chat.call_status=="call" && document.getElementById('callpy_iframeid').contentWindow.location.href != data["url"]))))){
                          //запрещаем скроллить, если не идет удаленное управление или сообщение пришло на неактивную вкладку
                      }else{
                          if (m_callpy.m_chat.call_status!="call") m_callpy.m_control.scroll(data);
                          else _this.to_proxy_client(data);
                      }

                  }
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientObserved())
                  {
                      if (m_callpy.m_manager.proxy_screen && m_callpy.m_manager.isClientSelected(data["site_id"], data["key"]))
                      {
                          m_callpy.client_data.tab_visibility = 1;
                          m_callpy.m_manager.frameScrollPosition = data["height"];
                          if (data["width"]){
                              //если появляется горизонтальный скролл страницы, то скроллим элемент proxy_screen_wrapper на основной странице, т.к. в самом фрейме вообще нет скролла
                              $jcallpy("#proxy_screen_wrapper").scrollLeft(data["width"]);
                          }
                          _this.to_proxy(data);
                      }
                  }
                  break;
              case "scroll_cw":
                  m_callpy.m_manager.scroll_cw(data);
                  break;
              case "input_field": //изменена форма input или textarea
              case "textarea_field":
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientObserved() && m_callpy.m_manager.isClientSelected(data["site_id"], data["key"])){
                      if (data["input"]["id"] != "callpy_chat_input_box")_this.to_proxy(data);
                      else {
                          $jcallpy.chat('typing', {text: data["value"]});
                      }
                  }else if (m_callpy.m_user && localStorage.getItem("callpy_control_flag")=="2"){
                      if (m_callpy.m_storage.activeTab || (m_callpy.m_chat.call_status!="call" && window.location.href == data["url"]) || (m_callpy.m_chat.call_status=="call" && document.getElementById('callpy_iframeid').contentWindow.location.href == data["url"])){
                          if (data["input"]["id"] != "callpy_chat_input_box"){

                              if (m_callpy.m_chat.call_status!="call"){
                                  if (data["action"]=="input_field") m_callpy.m_control.input_field(data);
                                  else m_callpy.m_control.textarea_field(data);
                              }else{
                                  _this.to_proxy_client(data);
                              }

                          }
                      }
                  }
                  break;
              case "select_field":
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientObserved() && m_callpy.m_manager.isClientSelected(data["site_id"], data["key"])){
                      _this.to_proxy(data);
                  }else if (m_callpy.m_user && localStorage.getItem("callpy_control_flag")=="2"){
                      if (m_callpy.m_storage.activeTab || (m_callpy.m_chat.call_status!="call" && window.location.href == data["url"]) || (m_callpy.m_chat.call_status=="call" && document.getElementById('callpy_iframeid').contentWindow.location.href == data["url"])){
                          if (m_callpy.m_chat.call_status!="call"){
                              m_callpy.m_control.select_field(data);
                          }else{
                              _this.to_proxy_client(data);
                          }
                      }
                  }
                  break;
              case "writing_text":
                  if (m_callpy.m_user){
                      m_callpy.m_chat.managerWriting();
                  }
                  break;
              case "window_resize":
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientSelected(data["site_id"], data["key"]))
                  {
                      data["width"] = parseInt(data["width"]);
                      data["height"] = parseInt(data["height"]);
                      m_callpy.m_manager.set_display_size(data);
                  }
                  break;
              case "select_area":
                  if (m_callpy.m_user)
                  {
                      if (m_callpy.m_storage.activeTab || (!m_callpy.m_storage.activeTab && data["url"] && (window.location.href == data["url"]&&m_callpy.m_chat.call_status!="call" || m_callpy.m_chat.call_status=="call"&&data["url"]==document.getElementById('callpy_iframeid').contentWindow.location.href ))){
                          //m_callpy.m_gui_chat.select_remote(data);
                          //if ($jcallpy.callpy_call('status').status != "call"){
                          if (m_callpy.m_chat.call_status != "call"){
                              $jcallpy.callpy_select('create', {
                                  client_id: data["key"],
                                  element_id: data["element_id"],
                                  cords: {
                                      upLeft: {x: parseInt(data["x1"]), y: parseInt(data["y1"])},
                                      botRight: {x: parseInt(data["x2"]), y: parseInt(data["y2"])}
                                  }
                              });
                          }else m_callpy.m_bridge.to_proxy_client(data);

                      }
                  }
                  break;
              case "visual_message":
                  if (m_callpy.m_user)
                  {
                      if (m_callpy.m_storage.activeTab || (!m_callpy.m_storage.activeTab && data["url"] && (window.location.href == data["url"]&&m_callpy.m_chat.call_status!="call" || m_callpy.m_chat.call_status=="call"&&data["url"]==document.getElementById('callpy_iframeid').contentWindow.location.href ))){
                          //if ($jcallpy.callpy_call('status').status != "call"){
                          if (m_callpy.m_chat.call_status != "call"){
                              $jcallpy.callpy_pointer('create', {
                                  client_id: data["key"],
                                  element_id: data["element_id"],
                                  circle: {
                                      left: data["circle"].left,
                                      top: data["circle"].top
                                  },
                                  tooltip: {
                                      left: data["tooltip"].left,
                                      top: data["tooltip"].top
                                  },
                                  message: data['message']
                              });
                          }else m_callpy.m_bridge.to_proxy_client(data);

                      }
                  }
                  break;
              case "unselect_area":
                  /*
                  if (m_callpy.m_user)
                  {
                      m_callpy.m_gui_chat.select_remote(data);
                  }
                  */
                  localStorage.removeItem("callpy_control_flag");
                  $jcallpy.callpy_status('set', 'remote_control_end');
                  break;
              case "delete_select_area":
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientObserved() && m_callpy.m_manager.isClientSelected(data["site_id"], data["key"])) $jcallpy.tools('del_tools', {client_id: data["key"], site_id: data["site_id"], element_id: data["element_id"], type: "select"});
                  break;
              case "delete_visual_message":
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientObserved() && m_callpy.m_manager.isClientSelected(data["site_id"], data["key"])) $jcallpy.tools('del_tools', {client_id: data["key"], site_id: data["site_id"], element_id: data["element_id"], type: "pointer"});
                  break;
              case "set_elements":
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientObserved())
                  {
                      m_callpy.m_manager.set_elements(data);
                  }
                  break;
              case "remote_control_request": //peer запрос на удаленное управление
                  //if (m_callpy.m_gui_chat)
                  //{
                      localStorage.setItem("callpy_control_flag", "1");
                      //GUI: необходима функция, которая просто отобразит принять/отклонить поверх чата (ВНЕ блока callpy) вместо той, что ниже:
                      //m_callpy.m_gui_chat.request_remote();
                      $jcallpy.callpy_status('set', 'remote_control_on');
                  //}
                  break;
              case "remote_control_request_cancel": //от менеджера клиенту - отмена запроса УУ
                  //if (m_callpy.m_gui_chat)
                  //{

                      //GUI: здесь должна вызываться GUI функция, которая удаляет "принять/отклонить" УУ
                      //$jcallpy('#callpy_request_remote_wrapper').remove();
                      //$jcallpy('#callpy_setting_wrap_overlay').remove();
                      //$jcallpy('#callpy_remote_connected_wrap').remove();

                      localStorage.removeItem("callpy_control_flag");
                      $jcallpy.callpy_status('set', 'remote_control_off');
                  //}
                  break;
              case "remote_control_answer":
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientObserved())
                  {
                      m_callpy.m_manager.remote_control_answer(data);
                  }
                  break;
              case "remote_observe_request": //peer запрос на удаленное управление
                  $jcallpy.callpy_status('set', 'remote_observe_on');
                  break;
              case "auth_access":
                  m_callpy.m_manager.auth_access(data);
                  break;
              case "remote_observe_request_cancel": //от менеджера клиенту - отмена запроса УУ
                  $jcallpy.callpy_status('set', 'remote_observe_off');
                  break;
              case "click":
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientObserved())
                  {
                      m_callpy.m_manager.click(data);
                  }
                  if (m_callpy.m_control)
                  {
                      //клик клиенту передаем только на активную вкладку

                      //TODO: раскомментить позже, когда будет заглушка у менеджера
                      if (m_callpy.m_storage.activeTab == true || (m_callpy.m_chat.call_status!="call" && window.location.href == data["url"]) || (m_callpy.m_chat.call_status=="call" && document.getElementById('callpy_iframeid').contentWindow.location.href == data["url"])){
                          if (m_callpy.client_data.type=="1" && localStorage.getItem("callpy_control_flag")!="2"){
                              //запрещаем кликать, если не идет удаленное управление
                          }else{

                              if (m_callpy.m_chat.call_status!='call')
                                  m_callpy.m_control.click(data);
                              else{
                                  //m_callpy.m_control.click(data);
                                  _this.to_proxy_client(data);
                              }

                          }
                      }
                  }
                  break;
              case "mouse_position":
                  if (m_callpy.m_manager && m_callpy.m_manager.isClientObserved()){
                      m_callpy.m_manager.mouse_position(data);
                  }
                  break;
              case "notification":
                  if (m_callpy.m_manager) m_callpy.m_manager.gotNotification(data);
                  break;
              //TODO: в обработчик сообщений в индивидульный канал консультанта
              case 'drop_session': //разавторизовать менеджера (когда входит, например, с другого компа)
              /*
                  if (m_callpy.m_manager){
                  if (data['session']==m_callpy.m_cookie.get_cookie("PHPSESSID")){
                      window.location.href = callpy_global.php_server;
                  }
              }
              */
              break;
              //TODO: в обработчик сообщений в индивидульный канал консультанта
              case 'force_drop_session': //разавторизовать менеджера (при увольнении или удаления сайта из БД)
                  if (m_callpy.m_manager){
                          window.location.href = "/manager/logout/";
                  }
                  break;
              case 'site_settings_changed':
                  m_callpy.m_chat.site_settings_changed(data);
                  break;
              case 'new_goal':
                  //Обработка сообщения только для клиента (для консультанта для новой панели свой файл cbridge)
                  if (m_callpy.m_user){
                      m_callpy.m_user.new_goal(data);
                  }
                  break;
              case 'manager_status_changed':
                  if (m_callpy.client_data.type == 1){
                      if ((m_callpy.managers_list[data["manager"]].status == 2 || m_callpy.managers_list[data["manager"]].status == 3) && data["status"] == 1) callpy_api.events._fireCallback("callEnd");
                      if (data["status"] == 2) callpy_api.events._fireCallback("dialupStart");
                      if (data["status"] == 3) callpy_api.events._fireCallback("callStart");
                      m_callpy.managers_list[data["manager"]].status = data["status"];
                  }
                  break;
              case 'manager_globalStatus_changed':
                  if (m_callpy.client_data.type == 1){
                      if (m_callpy.managers_list[data["manager"]]) m_callpy.managers_list[data["manager"]].globalStatus = data["globalStatus"];
                      callpy_api.events._fireCallback("managerStatus", data["globalStatus"]);
                  }
                  break;
              case 'manager_name_changed':
                  if (m_callpy.client_data.type == 1) {
                      /*if (typeof data.name == "string") {
                          $jcallpy('#callpy_global_lable_body_name, #callpy_chat_consultant_name').html(data.name);
                          m_callpy.managers_list[m_callpy.client_data.peer_key].name = data.name;
                      }
                      if (typeof data.position == "string") {
                          $jcallpy('.callpy_global_lable_body_title').html(data.position);
                          m_callpy.managers_list[m_callpy.client_data.peer_key].position = data.position;
                      }
                      $jcallpy.callpy_lable('size');
                      m_callpy.m_storage.saveHtml();*/
                      m_callpy.managers_list[m_callpy.client_data.peer_key].name = data.name;
                      m_callpy.managers_list[m_callpy.client_data.peer_key].position = data.position;
                      $jcallpy.callpy_consultant('set');
                  }else{
                      //TODO: изменять данные в списке консультанта
                  }
                  break;
              case "manager_avatar_changed":
                  if (m_callpy.client_data.type == 1){
                      m_callpy.managers_list[m_callpy.client_data.peer_key].avatar = data.avatar;
                      $jcallpy.callpy_consultant('set');
                  }
                  break;
              case 'icecandidate':
                  //m_callpy.m_flash.oncandidate(data);
                  break;
              case 'description':
                  //if (data["descriptor"].type == "offer") m_callpy.m_flash.onoffer(data);
                  //else m_callpy.m_flash.onanswer(data);
                  break;
              case 'changeCallState':
                  //m_callpy.m_flash.changeCallState(data);
                  break;
              case 'ping':

                  if (data["pingtype"]=="request") m_callpy.m_flash.ping_request(data);
                  else{
                      //ответ на ping запрос приходит во все вкладки, но обрабатывать надо строго там, где начинали звонок (или дозвон)
                      //TODO: NEW CHAT: заменить проверки
                      //if (m_callpy.m_user && $jcallpy.callpy_call('status').status!="call" && $jcallpy.callpy_call('status').status!="outcoming"){
                      if (m_callpy.m_user && m_callpy.m_chat.call_status!="call" && m_callpy.m_chat.call_status!="calling_to_manager"){
                      }else{
                          m_callpy.m_flash.ping_answer();
                      }
                  }

                  break;
              case 'update_activity':
                  //if (m_callpy.m_manager) m_callpy.m_manager.update_activity(data);
                  break;
              case 'update_status':
                  if (m_callpy.m_manager) m_callpy.m_manager.update_status(data);
                  break;
              //этот запрос приходит от демона, и говорит о том, что к Realplexor законнектился новый клиент, но данных по нему нет (о менеджере, местоположении и т.п.)
              //поэтому необходимо выполнить запрос для получения обновленной информации и назначении менеджера
              case 'disconnect_request':
                  if (m_callpy.m_user) m_callpy.m_user.disconnect_request();
                  break;
              case 'disconnect_answer':
                  if (m_callpy.m_user) m_callpy.m_user.disconnect_answer(data);
                  break;
              case 'dscnt_from_rplx': //принудительно отключаем клиента от realplexor (отписываемся от канала). Необходимо, например, при обновлениях. Вызывается искусственно
                  if (m_callpy.client_data.type==1){
                      m_callpy.realplexor.unsubscribe(m_callpy.client_data.site_id+"_c_"+m_callpy.client_data.key+"_"+m_callpy.client_data.channel, null);
                      m_callpy.realplexor.execute();
                  }
                  break;
              case 'userData':
                  if (m_callpy.m_manager) m_callpy.m_manager.userData(data);
                  break;
              case 'formData':
                  if (m_callpy.m_manager) m_callpy.m_manager.formData(data);
                  break;
              case 'form_field_added':
                  if (m_callpy.m_manager) m_callpy.m_manager.depFieldAdded(data);
                  else m_callpy.m_user.depFieldAdded(data);
                  break;
              case 'form_field_changed':
                  if (m_callpy.m_manager) m_callpy.m_manager.depFieldChanged(data);
                  else m_callpy.m_user.depFieldChanged(data);
                  break;
              case 'form_added':
                  if (m_callpy.m_manager) m_callpy.m_manager.depFormAdded(data);
                  else m_callpy.m_user.depFormAdded(data);
                  break;
              case 'form_deleted':
                  if (m_callpy.m_manager) m_callpy.m_manager.depFormDeleted(data);
                  else m_callpy.m_user.depFormDeleted(data);
                  break;
              case 'form_changed':
                  if (m_callpy.m_manager) m_callpy.m_manager.depFormChanged(data);
                  else m_callpy.m_user.depFormChanged(data);
                  break;
              case 'form_field_deleted':
                  if (m_callpy.m_manager) m_callpy.m_manager.depFieldDeleted(data);
                  else m_callpy.m_user.depFieldDeleted(data);
                  break;
              case 'fill_form':
                  if (m_callpy.m_user) m_callpy.m_user.fillForm(data);
                  break;
              case 'department_added':
                  if (m_callpy.m_manager) m_callpy.m_manager.depAdded(data);
                  else m_callpy.m_user.depAdded(data);
                  break;
              case 'department_edited':
                  if (m_callpy.m_manager) m_callpy.m_manager.depEdited(data);
                  else m_callpy.m_user.depEdited(data);
                  break;
              case 'departmentConsult':
                  if (m_callpy.m_manager) m_callpy.m_manager.departmentConsult(data);
                  else m_callpy.m_user.departmentConsult(data);
                  break;
              case 'requireAuth':
                  if (m_callpy.m_user){
                      if (!callpy_api.chat.visibility) callpy_api.chat('show');
                      $jcallpy.callpy_status('set', 'login_show');
                  }
                  break;
              case 'notify':
                  if (m_callpy.m_manager){
                      m_callpy.m_chat.notify(data);
                  }
                  break;
              case 'dialog_closed':
                  if (m_callpy.m_user){
                      m_callpy.m_chat.dialogClosed(data);
                      m_callpy.m_autos.checkAllConditions({closing_dialog: true});
                  }
                  break;
              case 'add_to_dialog':
                  m_callpy.m_chat.add_to_dialog(data);
                  break;
              case 'dialog_message':
                  m_callpy.m_chat.dialog_message(data);
                  break;
              case 'new_participant':
                  m_callpy.m_chat.dialog_new_participant(data);
                  break;
              case 'remove_participant':
                  m_callpy.m_chat.dialog_remove_participant(data);
                  break;
              case "setAuthDataLs":
                  console.log("Auth!", data);
                  if (data["token"].length > 0){
                      localStorage["credentials"] = JSON.stringify({access_token: data["token"], email: data["email"]});
                      //сразу же перезагружаем страницу
                      window.location.reload();
                  }else{
                      localStorage["credentials"] = null;
                  }
                  break;
              case 'all_managers_busy':
                  //сообщение от сервера в ответ на попытку звонка, что все менеджеры отдела заняты
                  $jcallpy.callpy_message('_addSys', {
                      type: 'callpy_state_fields',
                      text: 'В настоящее время все операторы заняты. Пожалуйста оставьте свои контакты или оставайтесь на сайте и первый освободившийся оператор свяжется с вами по видео.',
                      title: 'Оператор занят',
                      phone: true,
                      email: true,
                      busy: true
                  });
                  break;
                  //TODO: в мобильной версии
              case 'screen_share':
                  if (m_callpy.m_user){
                      m_callpy.m_chat.screen_share(data);
                  }
                  if (m_callpy.m_manager){
                      m_callpy.m_chat.screen_share(data);
                  }
                  break;
          }
        }
    };

    this.getController = function (action){
        var cntrl = "d";
        switch (action)
        {
            case "add_phrase":
            case "edit_phrase":
            case "delete_phrase":
            case "get_scripts_mng":
            case "select_new_user":
            case "change_manager":
            case "tabStats":
                cntrl = (m_callpy.client_data.type!=1||action!="change_manager"?"mngr":"d");
                break;
            default:
                cntrl = "d";
                break;
        }
        return cntrl;
    }

    this.send_data = async function(where, data, callback)
    {
        var result = false;
        if (m_callpy.client_data.type != 3 && m_callpy.client_data.type != 4) //&& _this.flash_object)
        {
            try
            {
                data["where"] = where;
                if (document.charset!="UTF-8") data["charset"] = document.charset;
                if (where != "to_php")
                {                   
                  const isLocalhost = window?.location?.origin.indexOf('localhost:')!==-1

                  let formData = new FormData()
                  function objectToFormData(obj, form = null, namespace = '') {
                    const formData =  new FormData()
                    const isArr = Array.isArray(obj)
                    for (const key in obj) {
                      if (!(obj.hasOwnProperty(key)) && obj[key] === null || obj[key] === undefined) {
                        continue
                      }
          
                      const formKey = namespace ? (isArr? namespace[key] : namespace[key]) : key
          
                      if (obj[key] instanceof Date) {
                        formData.append(formKey, obj[key].toISOString());
                      } else if (obj[key] instanceof File) {
                        formData.append(formKey, obj[key]);
                      } else if (typeof obj[key] !== 'object') {
                        formData.append(formKey, obj[key].toString());
                      } else if (Array.isArray(obj[key])) {
                        obj[key].forEach((item, index) => {
                          const arrayKey = ` ${formKey}[${index}]`;
                          objectToFormData(item, formData, arrayKey);
                        });
                      } else {
                        objectToFormData(obj[key], formData, formKey);
                      }
                    }
                    return formData;
                  }
                  formData = objectToFormData(data) 
									if (!callback) {
										// $jcallpy.ajax({   type: "POST",
										// url: (location.protocol=="http:"?callpy_global.php_server.replace("https", "http"):callpy_global.php_server) + _this.getController(data["action"]) + "/",
										// data: data
										// });

										//console.log('callpy_global.php_server===>', callpy_global.php_server, data)
										try {
                                            
											fetch(((location.protocol=="http:"&&!isLocalhost)?callpy_global.php_server.replace("https", "http"):callpy_global.php_server) + _this.getController(data["action"]) + "/", {
												method: 'post',
												body: new URLSearchParams(formData),
												headers: {
                          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
												}
											})
	
										} catch (error) {
											console.error(error)
										}
									} else {
                    const response = await fetch(((location.protocol=="http:"&&!isLocalhost)?callpy_global.php_server.replace("https", "http"):callpy_global.php_server) + _this.getController(data["action"]) + "/", {
                      method: 'post',
                      body: new URLSearchParams(formData),
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                      }
                    })
                    if(response.ok) {
                      const responseBody = response.text().then(responseContent=> {
                        //console.log('success',response, responseBody, JSON.parse(responseContent))
                        callback(responseContent)
                      })
                      
                    }
									// $jcallpy.ajax({   type: "POST",
									// 	url: (location.protocol=="http:"?callpy_global.php_server.replace("https", "http"):callpy_global.php_server) + _this.getController(data["action"]) + "/",
									// 	data: data,
									// 	success: callback
									// });
									}
                }
                else
                {
                    $jcallpy.ajax({   type: "POST",
                        url: (location.protocol=="http:"?callpy_global.php_server.replace("https", "http"):callpy_global.php_server) + _this.getController(data["action"]) + "/",
                        data: data,
                        success:
                            function (msg)
                            {
                                if (msg)
                                {
                                    _this.from_flash(JSON.parse(msg));
                                }
                            }
                    });
                }
                result = true;
            }
            catch(e)
            {
                m_callpy.m_logger.log(_this.module_name + "Error", e);
            }

            return result;
        }
        if (m_callpy.client_data.type == 3)
        {
            _this.to_parent({action: where, data: data});
        }
        if (m_callpy.client_data.type == 4)
        {
            _this.to_parent_client({action: where, data: data});
        }
    };

    this.to_peer = function(data, callback)
    {
        console.log('(data', data)
        data['domain'] = m_callpy.client_data.site;
        if (m_callpy.client_data.peer_key != 0 && m_callpy.client_data.peer_type != 0 && m_callpy.client_data.type != 3 && m_callpy.client_data.type != 4)
        {
            data = _this.add_client_data(data);
            data = _this.add_peer_data(data);
            if (m_callpy.client_data.type==1) data = _this.add_channel_data(data);

            //m_callpy.m_logger.log(_this.module_name + "--->>> Peer", data);
            _this.send_data("to_fms", data, callback?callback:null);
            return true;
        }/*else if (data['action']=='send_automessage'){
            data = _this.add_client_data(data);
            m_callpy.m_logger.print_log(_this.module_name + "--->>> Peer", data, _this.module_log_rang);
            _this.send_data("to_fms", data);
            return true;
        }*/
        if (m_callpy.client_data.type == 3)
        {
            _this.send_data("to_peer", data, callback?callback:null);
        }
        if (m_callpy.client_data.type == 4)
        {
            _this.send_data("to_peer", data, callback?callback:null);
        }
    };

    this.to_php = function(data)
    {
        if (m_callpy.client_data.type==1) data = _this.add_channel_data(data);
        m_callpy.m_logger.log(_this.module_name + "--->>> PHP", data);
        _this.send_data("to_php", data);
    };

    this.to_fms = function(data, callback)
    {
        data = _this.add_client_data(data);
        if (m_callpy.client_data.type==1) data = _this.add_channel_data(data);
        //if (m_callpy.client_data.connected)
        //{
            m_callpy.m_logger.log(_this.module_name + "--->>> All", data);
            _this.send_data("to_fms", data, callback ? callback : null);
        //}
    };

    this.to_peer_or_group = function(data, peer, callback, withoutClientData)
    {
        if (!withoutClientData) data['domain'] = m_callpy.client_data.site;
        if (peer.type == "peer"){
            if (m_callpy.client_data.peer_key != 0 && m_callpy.client_data.peer_type != 0)
            {
                if (!withoutClientData) data = _this.add_client_data(data);
                data = _this.add_peer_data(data);
                data = _this.add_channel_data(data);

                m_callpy.m_logger.log(_this.module_name + "--->>> Peer", data);
                _this.send_data("to_fms", data, callback?callback:null);
                return true;
            }
        }else{
            if (!withoutClientData) data = _this.add_client_data(data);
            data = _this.add_peer_data(data);
            data = _this.add_group_data(peer, data);
            _this.send_data("to_fms", data, callback?callback:null);
        }

    };

    this.add_client_data = function (data)
    {
        data["site_id"] = m_callpy.client_data.site_id;
        data["key"] = m_callpy.client_data.key;
        data["type"] = m_callpy.client_data.type;

        return data;
    };

    this.add_peer_data = function (data)
    {
        data["peer_key"] = m_callpy.client_data.peer_key;
        data["peer_type"] = m_callpy.client_data.peer_type;

        return data;
    };

    this.add_channel_data = function (data)
    {
        data["channel"] = m_callpy.client_data.channel; //передаем зашифрованный канал для проверки подлинности клиентского запроса
        return data;
    }

    this.is_array = function (input)
    {
        return typeof(input)=='object'&&((input instanceof Array) || (input instanceof Object));
    };

    this.format_data = function (data)
    {
        var str = _this.data_to_str(data, "&", null);
        return str.slice(0, str.length - 1);
    };

    this.data_to_str = function(data, sign, p_key)
    {
        (sign) ? sign : "&";

        var result = "";

        for (var key in data)
        {
            if (_this.is_array(data[key]))
            {
                result += _this.data_to_str(data[key], sign, (p_key) ? p_key + "[" + key + "]" : key);
            }
            else
            {
                result += ((p_key) ? p_key + "[" + key + "]" : key) + "=" + data[key] + sign;
            }
        }
        return result;
    };

    this.to_proxy = function (data)
    {
       m_callpy.m_manager.proxy_screen.postMessage(JSON.stringify(data), m_callpy.client_data.origin);
    };

    this.to_proxy_client = function (data)
    {
        document.getElementById('callpy_iframeid').contentWindow.postMessage(JSON.stringify(data), location.protocol+"//"+document.getElementById('callpy_iframeid').contentWindow.location.host);
    };

    this.to_parent = function (data)
    {
        //TODO: ограничение на origin
        //parent.postMessage(JSON.stringify(data), callpy_global.php_server.substr(0,callpy_global.php_server.length-1).replace("https", "http"));
        parent.postMessage(JSON.stringify(data), '*');
    };

    this.to_parent_client = function (data)
    {
        parent.postMessage(JSON.stringify(data), location.protocol+"//"+parent.location.host);
    };

    this.from_proxy = function (data)
    {
        try{

            data = JSON.parse(data);
            switch (data.action)
            {
                case "to_peer":
                    //если менеджер пытается послать клик, скролл или изменение поля (его фрейм ВСЕГДА генерирует эти события в родительское окно)
                    //но здесь мы отсылаем это клиенту только если идет удаленная навигация. А также подменяем URL на пустой, если у клиента есть активная вкладка
                    if (m_callpy.client_data.type == 2 && (data.data['action'] == 'scroll' || data.data['action'] == 'click' || data.data['action'] == 'input_field')){
                        if ($jcallpy.tools('status').navigate){
                            if (m_callpy.users_list[m_callpy.client_data.site_id][m_callpy.m_manager.selected_user].tabStatus=="1"){
                                data.data["url"] = "";
                            }
                        }else return;
                    }
                    _this.to_peer(data.data);
                    break;
                /*
                case "info":
                    m_callpy.m_manager.proxyScreenLocation = data["url"];
                    m_callpy.m_manager.go_url2(data["url_togo"]);
                    break;
                */
                case "get_cookies":
                    //отправляем в ифрейм куки только если до этого они еще не были получены (а значит, менеджер только что переключился на этого клиента)
                    if (m_callpy.client_data.peer_cookies == false && m_callpy.client_data.site_info[m_callpy.client_data.site_id]["outerAuth"]!=1){
                        _this.to_proxy(m_callpy.m_message.create_message("set_cookies", {
                            "cookies": m_callpy.client_data.peer_cookie
                        }));
                        m_callpy.client_data.peer_cookies = true;
                    }
                    break;
                case "get_data":
                    m_callpy.m_manager.getDataForProxy(data);
                    break;
                case "toolsData":
                    $jcallpy.tools('add_tools', data['toolsData']);
                    break;
                case "set_locationhref":
                    m_callpy.m_manager.proxyScreenLocation = data["url"];
                    //TODO: если идёт удалённая навигация, необходимо url передать клиенту и сравнить с текущим location клиента
                    if (m_callpy.m_manager.remote_control){
                        m_callpy.m_bridge.to_peer({action: "go_url", url: data["url"]});
                    }
                    break;
                //следим за активностью окна
                case "visibility":
                    if (data["status"]=="focus") m_callpy.m_manager.activeTab = true;
                    break;
                case "iframe_loaded": //скрипты в iframe загрузились, можно снимать заглушку
                    m_callpy.m_manager.load_frame_handler();
                    break;
                case "url_hash_changed": //от фрейма: там изменился хеш url. Возможно, необходимо послать клиенту go_url, если идёт удаленная навигация
                    if (m_callpy.m_manager.remote_control){
                        m_callpy.m_bridge.to_peer({action: "go_url", url: data["url"]});
                    }
                    break;
            }

        }catch(e){

        }
    };

    //обработчик события из iframe на стороне клиента (при разговоре)
    this.from_proxy_client = function (data)
    {
        try{
            data = JSON.parse(data);
            switch (data.action)
            {
                case "to_peer":
                    _this.to_peer(data.data);
                    break;
                case "focus":
                    m_callpy.m_storage.onfocus_handler({focusFrame: true});
                    break;
                case "blur":
                    //в фрейме сработало событие blur. Это означает, что либо клиент остался на странице, но сфокусировал основную страницу (например, нажал на чат),
                    //либо ушел со страницы вообще. В последнем случае основное окно не перехватит фокус и останется неактивным и можно вызвать обработчик onblur_handler
                    //таймаут - чтобы быть уверенным, что основное окно успеет получить фокус в случае переключения с фрейма на окно
                    //setTimeout(function(){
                        if (!m_callpy.m_storage.focusedWindow) m_callpy.m_storage.onblur_handler();
                    //},50);
                    break;
                case "iframe_loaded": //скрипты в iframe загрузились, сообщаем менеджеру go_url (на всякий случай, неизвестно, как именно произошла смена адреса в iframe)
                    //TODO: NEW CHAT: заменить проверки
                    //if ($jcallpy.callpy_call('status').status != "call")m_callpy.m_bridge.to_peer({action: "go_url", url: window.location.href, width: $jcallpy(document).width(), height: $jcallpy(document).height(), scroll: m_callpy.m_control.get_top_scroll(), elements: {selects: $jcallpy.callpy_select(), pointers: $jcallpy.callpy_pointer()}, noFocus: true, title: document.title});
                    if (m_callpy.m_chat.call_status != "call")m_callpy.m_bridge.to_peer({action: "go_url", url: window.location.href, width: $jcallpy(window).width(), height: $jcallpy(document).height(), scroll: m_callpy.m_control.get_top_scroll(), elements: {selects: $jcallpy.callpy_select(), pointers: $jcallpy.callpy_pointer()}, noFocus: true, title: document.title});
                    else m_callpy.m_bridge.to_peer({action: "go_url", url: document.getElementById("callpy_iframeid").contentWindow.location.href, width: $jcallpy(window).width(), height: $jcallpy(document).height(), scroll: document.getElementById('callpy_iframeid').contentWindow.m_callpy.m_control.get_top_scroll(), elements: {selects: document.getElementById('callpy_iframeid').contentWindow.$jcallpy.callpy_select(), pointers: document.getElementById('callpy_iframeid').contentWindow.$jcallpy.callpy_pointer()}, noFocus: true, title: document.getElementById('callpy_iframeid').contentWindow.document.title});
                    break;
            }
        }catch(e){

        }

    };

    this.from_parent = function (data)
    {
        try{

            data = JSON.parse(data);
            switch (data.action)
            {
                case "click":
                    m_callpy.m_control.click(data);
                    break;
                case "scroll":
                    //if (!data["smooth"])m_callpy.m_control.scroll(data);
                    //else $jcallpy(document.body).animate({ scrollTop: data['height'] }, 300);
                    m_callpy.m_control.scroll(data);
                    break;
                case "input_field":
                    m_callpy.m_control.input_field(data);
                    break;
                case "textarea_field":
                    m_callpy.m_control.textarea_field(data);
                    break;
                case "select_field":
                    m_callpy.m_control.select_field(data);
                    break;
                case "pointer_click":
                    $jcallpy.control('pointer', data['status']);
                    break;
                case "select_click":
                    $jcallpy.control('select', data['status']);
                    break;
                case "go_url":
                    window.location.href = data["url"];
                    break;
                case "block_click":
                    $jcallpy.control('block_click');
                    break;
                case "get_location":
                    _this.to_parent({"action": "info", "url": document.location.href, "url_togo": data["url"]});
                    break;
                case "get_locationhref":
                    _this.to_parent({"action": "set_locationhref", "url": document.location.href});
                    //если необходимо убрать заглушку:
                    if (data["tools"].select){
                        $jcallpy.control('select', true);
                    }
                    if (data["tools"].pointer) {
                        $jcallpy.control('pointer', true);
                    }
                    break;
                case "set_cookies":
                    m_callpy.m_control.set_cookies(data);
                    break;
                case "delete_tool":
                    if (data["type"]=="select") $jcallpy('#remote-select-page-box-' + data["element_id"]).remove();
                    else $jcallpy('#remote-control-circle' + data["element_id"] + ', #callpy_tooltip_pointer_block' + data["element_id"]).remove();
                    break;
                case "draw_elements":
                    if (data["deletePrevious"]) {
                        $jcallpy('.remote-selected-page-box').remove();
                        $jcallpy('.callpy_lable_tooltip_wrapper').remove();
                        $jcallpy('.remote-control-circle').remove();
                    }
                    for (var i = 0; i < data["elements"].selects.length; i++) {
                        $jcallpy.control('create_select', data["elements"].selects[i]);
                    }
                    for (var i = 0; i < data["elements"].pointers.length; i++) {
                        $jcallpy.control('create_pointer2', data["elements"].pointers[i]);
                    }

                    break;
            }

        }catch(e){

        }
    };

    //обработчик события из основного окна на стороне клиента (при разговоре, на самом деле клиент видит фрейм)
    this.from_parent_client = function (data)
    {
        try{
            data = JSON.parse(data);
            switch (data.action)
            {
                case "click":
                    m_callpy.m_control.click(data);
                    break;
                case "scroll":
                    m_callpy.m_control.scroll(data);
                    break;
                case "input_field":
                    m_callpy.m_control.input_field(data);
                    break;
                case "textarea_field":
                    m_callpy.m_control.textarea_field(data);
                    break;
                case "pointer_click":
                    $jcallpy.control('pointer', {active: data.active});
                    break;
                case "select_click":
                    $jcallpy.control('select', {active: data.active});
                    break;
                case "go_url":
                    window.location.href = data["url"];
                    break;
                case "block_click":
                    $jcallpy.control('block_click');
                    break;
                case "select_area":
                    $jcallpy.callpy_select('create', {
                        client_id: data["key"],
                        element_id: data["element_id"],
                        cords: {
                            upLeft: {x: parseInt(data["x1"]), y: parseInt(data["y1"])},
                            botRight: {x: parseInt(data["x2"]), y: parseInt(data["y2"])}
                        }
                    });
                    break;
                case "visual_message":
                    $jcallpy.callpy_pointer('create', {
                        client_id: data["key"],
                        element_id: data["element_id"],
                        circle: {
                            left: data["circle"].left,
                            top: data["circle"].top
                        },
                        tooltip: {
                            left: data["tooltip"].left,
                            top: data["tooltip"].top
                        },
                        message: data['message']
                    });
                    break;
            }
        }catch(e){

        }
    };
};